import { APIS_RAOS_INVENTORY } from "@/constants/apis";
import axios from "axios";
import { ref } from "vue";
import { TOKEN } from '@/constants/labels';
import { showConsoleError } from '@/functions/errors'


export async function getAllPerforadorasData() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_RAOS_INVENTORY.value.getAllPerforadorasData, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function getAllUsersData() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_RAOS_INVENTORY.value.getAllUsersData, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function postAddUserData(params: any) {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .post(APIS_RAOS_INVENTORY.value.postAddUserData, params, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      statusAxios.value = { status: 200, data: finalData.value, showGraphs: true }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function postEditUserData(params: any) {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .post(APIS_RAOS_INVENTORY.value.postEditUserData, params, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      statusAxios.value = { status: 200, data: finalData.value, showGraphs: true }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function postDeleteUserData(params: any) {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .post(APIS_RAOS_INVENTORY.value.postDeleteUserData, params, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      statusAxios.value = { status: 200, data: finalData.value, showGraphs: true }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}
